import { Distributionanalyticsv1ComputePortfolioAnalyticsRequest, TypesMetadataValue, V1Benchmark, V1BenchmarkComponent, V1InputPortfolio, V1PortfolioPosition } from '@blk/portfolio-security-server/analytics/portfolio-analytics';
import { BenchmarkPortfolio, InputPortfolio } from '@blk/wealth-web-endpoint';
import { WwePortfolioAnalysisServiceParams } from '@ddt-web/data-service';

import { mapIdentifiersToSecurityIdentifiersMap } from './asset-resolve-request-mapping';


export const mapPortfolioAnalysisParamsToDistributionanalyticsv1ComputePortfolioAnalyticsRequest = (apiParams: WwePortfolioAnalysisServiceParams): Distributionanalyticsv1ComputePortfolioAnalyticsRequest => {
	const portfolios: Array<V1InputPortfolio> = apiParams.body.portfolios.map(portfolio =>
		mapPortfolioToV1InputPortfolio(portfolio, apiParams.body['simulatedPerformanceUserInputs']?.feeOverride)
	);

	const benchmarkPortfolio: V1InputPortfolio = apiParams.body.benchmark ? mapPortfolioToV1Benchmark(apiParams.body.benchmark) : null;

	return {
		analyticsTypes: apiParams.analytics,
		pkg: apiParams.pkg,
		asOfDate: apiParams.date,
		portfolios,
		benchmarkPortfolio,
		rc: apiParams.rc,
		skipCache: apiParams.skipCache,
		simulatedPerformanceUserInput: apiParams.body['simulatedPerformanceUserInputs'],
		preview: apiParams.preview
	} as Distributionanalyticsv1ComputePortfolioAnalyticsRequest;
};

export const mapPortfolioToV1InputPortfolio = (portfolio: InputPortfolio, customAdvisoryFee?: number) => {

	const pasPositions = portfolio.positions.map(position => {
		return {
			id: position.id,
			weight: position.weight,
			identifiers: mapIdentifiersToSecurityIdentifiersMap(position.identifiers)
		} as V1PortfolioPosition;
	});

	if (portfolio.metadata.ruleData) {
		portfolio.metadata.ruleData = Object.assign({}, { stringValue: portfolio.metadata.ruleData });
		portfolio.metadata.statuses = Object.assign({}, { stringValue: portfolio.metadata.statuses });
		portfolio.metadata.customAdvisoryFee = Object.assign({}, { numberValue: customAdvisoryFee });
	}

	return {
		currencyCode: portfolio.currency,
		id: portfolio.id,
		metadata: portfolio.metadata,
		positions: pasPositions
	} as V1InputPortfolio;
};

export const mapPortfolioToV1Benchmark = (portfolio: BenchmarkPortfolio) => {

	const components = portfolio.components.map(component => {

		let posInfo: { [key: string]: TypesMetadataValue } = {};

		for (const identifierType in component.identifiers) {
			if (component.identifiers.hasOwnProperty(identifierType)) {
				posInfo = {
					...posInfo,
					[identifierType]: {
						stringValue: component.identifiers[identifierType]
					}
				};
			}
		}

		return {
			id: component.id,
			weight: component.weight,
			posInfo
		} as V1BenchmarkComponent;
	});

	return {
		currencyCode: portfolio.currency,
		id: portfolio.id,
		components
	} as V1Benchmark;

};


